var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-tab',{attrs:{"title":_vm.$options.i18n.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }